import React, {Component} from 'react';
import {withStyles} from "@material-ui/core";
import classNames from "classnames";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import Button from "@material-ui/core/Button";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import {
    renderMilisecondsToTimeDuration,
} from "../../../utils/datetimehelp";
import ListItem from "@material-ui/core/ListItem";
import  ClockSVGIcon  from "../../../assets/svg/clock.jsx";
import Icon from "@material-ui/core/Icon";
import {useHistory} from "react-router-dom";

const styles = theme => ({
    textField: {
        minWidth: 250,
        marginRight: theme.spacing(1),
        position: 'relative'
    },
    container: {
        marginBottom: theme.spacing(1) * 2
    },
    marginBottom: {
        marginBottom: '15px',
        minWidth: '250px'
    },
    button: {
        margin: theme.spacing(1)
    },
    card: {
        marginTop: '15px'
    },
    expansionPanelSummaryRoot: {
        height: '40px',
        backgroundColor: '#cacaca',
        //backgroundColor: '#85b4d5',
        //  backgroundColor: '#f5e0b2',  // amarelo opaco
        // backgroundColor: '#a4c8e0',
        // backgroundColor: COLOR_chart_series_first_line,
        //backgroundColor: '#387199'

    },

    expansionPanelSummaryContent: {
        display: 'flex',
        justifyContent: 'space-between',

    },
    red: {
        backgroundColor: 'red'
    }

})




    const EtapaFoto = ({ classes, foto, index }) => {

        const history = useHistory();

        let tmed = 0;
        if (foto.tempoTotalEspera && foto.quantidadeOS && foto.tempoTotalEspera > 0 && foto.quantidadeOS > 0 ) {
            tmed =  new Date(Math.round(foto.tempoTotalEspera / foto.quantidadeOS)) ;
        }

        foto.os.sort(function (a, b) {
            var aSize = (a.ordemServicoId * 1);
            var bSize = (b.ordemServicoId * 1);
            var aLow = a.etapaId;
            var bLow = b.etapaId;
            // console.log(aLow + " | " + bLow);

            if(aSize == bSize)
            {
                return (aLow < bLow) ? -1 : (aLow > bLow) ? 1 : 0;
            }
            else
            {
                return (aSize < bSize) ? -1 : 1;
            }
        });

        const clickNewTab  = (url) => {
            const win = window.open(`${url}`, "_blank");
            win.focus();
        }

        console.log("etapaFoto",foto)

        const desc = foto.peDescricao? foto.peDescricao : (foto.descricao? foto.descricao : "N/A");

        return (
            <ExpansionPanel key={index} style={{margin: '10px'}}>
                <ExpansionPanelSummary  classes={{
                    root: classes.expansionPanelSummaryRoot,
                    content: classes.expansionPanelSummaryContent
                }}   expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="h5">{desc.toUpperCase()}</Typography>
                    <Typography variant="h5"> fila: {foto.quantidadeOS}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails  style={{display:"flex", flexFlow:"row wrap"}}>
                    <Card style={{display:"flex", flexGrow:12, flexFlow:"row wrap"}}>
                    <Card style={{flexGrow:3, flexShrink:0, flexBasis:'33.33%', justifyContent:'space-between'}}>
                        <ListItem style={{display:'flex', justifyContent:'space-between', paddingLeft: '15px',paddingRight: '45px'}}>
                            <Typography  style={{fontSize: '0.8rem'}}>PLANTA</Typography>
                            <Typography  style={{fontSize: '1.1rem'}}>{foto.estabelecimentoId}</Typography>
                        </ListItem>
                        <ListItem style={{display:'flex', justifyContent:'space-between', paddingLeft: '15px',paddingRight: '45px'}}>
                            <Typography  style={{fontSize: '0.8rem'}}>CONCLUIDOS DESDE 00:00h</Typography>
                            <Typography  style={{fontSize: '1.1rem'}}>{foto.concluidos}</Typography>
                        </ListItem>
                        <ListItem style={{display:'flex', justifyContent:'space-between', paddingLeft: '15px',paddingRight: '45px'}}>
                            <Typography  style={{fontSize: '0.8rem'}}>TEMPO MÉDIO DE ESPERA NA FILA</Typography>
                            <Typography  style={{fontSize: '1.1rem'}}>{ renderMilisecondsToTimeDuration(tmed) }</Typography>
                        </ListItem>


                    </Card>
                        <Card style={{flexGrow:9, flexShrink:0, flexBasis:'66.66%', justifyContent:'space-between'}}>
                    {foto.os.map((fe,ix)=> {
                        let tmedOS = -1;
                        if (fe.DTUltimaEtapa && new Date(fe.DTUltimaEtapa).getFullYear() > 2000) {
                            tmedOS = new Date(new Date().getTime() - new Date(fe.DTUltimaEtapa).getTime())
                        }

                     //   console.log("RENDER FOTO", fe.ordemServicoId, tmedOS);

                        const tmedOSmin = tmedOS / 1000 / 60;


                        return(<Button
                            key={ix}
                            variant="contained"
                            color="primary"
                            onClick={() => clickNewTab(`/ordemServico/${fe.ordemServicoId}`) }
                            className={ classNames(
                                  {
                                      [classes.button] : true,
                                      [classes.red] : (foto.etapaId === 18 && tmedOSmin < 20)
                                  })}
                            startIcon={<ClockSVGIcon/>}

                        >
                            {`${fe.ordemServicoId}  `}

                            <Icon style={{marginLeft: '10px', width: '1em', height: '1em', fontSize: '0.8em'}}><img src={ClockSVGIcon} /></Icon>
                            {renderMilisecondsToTimeDuration(tmedOS)}

                        </Button>)
                    })}
                    </Card>
                    </Card>
                </ExpansionPanelDetails>
            </ExpansionPanel>
        )
    }

export default withStyles(styles, {withTheme: true})(EtapaFoto);
